/* Store Ec · GUARDIA DEL PAGO CON TARJETA (se carga en <head>, sin defer, antes que cualquier app).
   Regla: NUNCA llega al pago de Shopify (tarjeta) un carrito con productos nacionales (se pagan al recibir con EasySell).
   Cubre: clics en enlaces/botones a /checkout (también botones name="checkout" y los de apps o cajones),
   envíos de formularios del carrito, el cupón del carrito, enlaces directos /cart/123:1 y, donde el navegador
   lo permite (Navigation API), cualquier location.href = '/checkout'.
   Qué hace si hay nacionales:
   · solo nacionales  → abre el formulario de pago al recibir (página del producto con ?pedido=carrito);
   · mezclado         → lleva al carrito, donde el cliente elige qué pedir primero (aviso con 2 botones). */
(function(){
  'use strict';
  if (window.X13G) return;
  var G = window.X13G = { ok: false };
  var NAC = function(){ return window.X13_NACIONAL || []; };
  function esPago(url){
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin && !/\.myshopify\.com$/.test(u.hostname)) return false;
      return /^\/(checkout|checkouts)(\/|$|\?)/.test(u.pathname) || /^\/cart\/\d+:\d+/.test(u.pathname);
    } catch (e) { return false; }
  }
  G.esPago = esPago;
  function carrito(){ return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function(r){ return r.json(); }); }
  function esNac(it){ return NAC().indexOf(it.product_id) > -1; }
  function aviso(t){ try { if (window.X13T && window.X13T.aviso) window.X13T.aviso(t, true); } catch (e) {} }

  /* Decide a dónde va el cliente. seguir() = continuar al pago (solo si NO hay nacionales). */
  G.revisar = function(seguir){
    if (G.ocupado) return; G.ocupado = true;
    carrito().then(function(c){
      var items = c.items || [], nac = items.filter(esNac), imp = items.filter(function(i){ return !esNac(i); });
      if (!nac.length) { G.ok = true; seguir(); return; }
      if (!imp.length) {
        aviso('Estos productos se pagan al recibir: completa tus datos y no necesitas tarjeta.');
        location.href = String(nac[0].url || '/collections/nacional').split('?')[0] + '?pedido=carrito';
        return;
      }
      aviso('Tu carrito tiene productos que se pagan al recibir y otros con tarjeta: elige cuáles pedir primero.');
      if (location.pathname === '/cart') {
        var caja = document.querySelector('[data-x13-linea-pago]');
        if (caja) { caja.scrollIntoView({ block: 'center' }); var b = caja.querySelector('button'); if (b) b.focus(); G.ocupado = false; }
        else location.reload();
      } else location.href = '/cart';
    }).catch(function(){ G.ocupado = false; location.href = '/cart'; });
  };
  /* Para los botones propios que ya apartaron los nacionales (x13-lineas.js). */
  G.irSinRevisar = function(url){ G.ok = true; location.href = url; };

  function elementoDe(e){
    var ruta = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < ruta.length; i++) {
      var el = ruta[i]; if (!el || !el.tagName) continue;
      var tag = el.tagName;
      if (tag === 'A' && el.getAttribute('href') && esPago(el.href)) return { url: el.href };
      if ((tag === 'BUTTON' || tag === 'INPUT') && el.name === 'checkout') return { url: '/checkout', form: el.form, boton: el };
      if (el.hasAttribute && el.hasAttribute('data-x13-pedir')) return null; /* botones del aviso del carrito */
    }
    return null;
  }

  window.addEventListener('click', function(e){
    if (G.ok) return;
    var x = elementoDe(e); if (!x) return;
    e.preventDefault(); e.stopImmediatePropagation();
    G.revisar(function(){
      if (x.form) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = ''; x.form.appendChild(h); HTMLFormElement.prototype.submit.call(x.form); }
      else location.href = x.url;
    });
  }, true);

  window.addEventListener('submit', function(e){
    if (G.ok) return;
    var f = e.target, s = e.submitter;
    var accion = f.getAttribute('action') || '';
    var vaPago = esPago(f.action) || (s && s.name === 'checkout') || !!f.querySelector('input[name="checkout"]');
    /* Enter en el carrito: el envío implícito usa el primer botón de envío del formulario (puede ser «Pagar»). */
    if (!vaPago && /\/cart\/?$/.test(accion) && !s) {
      var primero = document.querySelector('[form="' + f.id + '"][type="submit"], #' + (f.id || 'x') + ' [type="submit"]');
      if (primero && primero.name === 'checkout') vaPago = true;
    }
    if (!vaPago) return;
    e.preventDefault(); e.stopImmediatePropagation();
    G.revisar(function(){
      if (!f.querySelector('input[name="checkout"]')) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = ''; f.appendChild(h); }
      HTMLFormElement.prototype.submit.call(f);
    });
  }, true);

  /* Cualquier otra navegación por código (location.href, apps, cupón) en navegadores con Navigation API. */
  if (window.navigation && navigation.addEventListener) {
    navigation.addEventListener('navigate', function(e){
      if (G.ok || !e.cancelable || !e.destination || !esPago(e.destination.url)) return;
      e.preventDefault();
      var url = e.destination.url;
      G.revisar(function(){ location.href = url; });
    });
  }
  /* Al volver con «atrás» desde el pago, la página puede venir de la memoria del navegador: se reinicia la guardia. */
  window.addEventListener('pageshow', function(){ G.ok = false; G.ocupado = false; });
})();
